import styles from "./MarketplaceStates.module.scss";

export function MarketplaceEmptyState({ message = "No products found." }) {
  return (
    <section className={styles.state}>
      <div className={styles.glowPink} />
      <div className={styles.glowBlue} />
      <div className={styles.gridFx} />

      <div className={styles.inner}>
        <div className={styles.iconShell}>
          <div className={styles.emptyIcon}>
            <span />
            <span />
            <span />
          </div>
        </div>

        <p className={styles.kicker}>Marketplace</p>
        <h3 className={styles.title}>Nothing here yet</h3>
        <p className={styles.message}>{message}</p>
      </div>
    </section>
  );
}

export function MarketplaceLoadingState({
  message = "Loading marketplace...",
}) {
  return (
    <section className={styles.state}>
      <div className={styles.glowPink} />
      <div className={styles.glowBlue} />
      <div className={styles.gridFx} />

      <div className={styles.inner}>
        <div className={styles.iconShell}>
          <div className={styles.spinner}>
            <span className={styles.spinnerRing} />
            <span className={styles.spinnerCore} />
          </div>
        </div>

        <p className={styles.kicker}>Marketplace</p>
        <h3 className={styles.title}>Syncing listings</h3>
        <p className={styles.message}>{message}</p>
      </div>
    </section>
  );
}
